import React, { useContext, useEffect, useState } from 'react'
import CommonModal from '../../UiKits/Modals/common/modal'
import { Table } from 'antd'
import { getCourseNameFromCourseId } from '../../../utils/course'
import courseContext from '../../../Helper/Courses'
import moment from 'moment'
import { Btn } from '../../../AbstractElements'

const generalInfoColumns = [{
  title: "Email",
  dataIndex: "email",
},
{
  title: "Name",
  dataIndex: "fullName",
},
{
  title: "Contact No",
  dataIndex: "contactNo",
}]


const FeeHistory = ({ data, open, setOpen, module, updateStudents, courseStudents }) => {
  const [fees, setFees] = useState([]);
  const { courses } = useContext(courseContext)
  const feeData = [
    {
      title: "COURSE NAME",
      dataIndex: "courseName",
    },
    {
      title: "MODULE",
      render: (fee) => fee.index == 0 ? 'First' : 'Second'
    },
    {
      title: "DATE",
      render: (fee) => moment(fee.date.seconds * 1000).format("L")

    },
    {
      title: "STATUS",
      dataIndex: "status",
    },
    {
      title: "FEE",
      dataIndex: "feeAmount",
    },
    {
      title: "ACTION",
      render: () => <Btn attrBtn={{ color: "primary" }}>View</Btn>
    }
  ]


  useEffect(() => {
    const fee = [];
    data?.courses.map((course) => {
      let courseName = getCourseNameFromCourseId(courses, course.courseId);
      course.feeScreenshots.map((module, index) => {
        if (module.skipModule) return
        fee.push({
          courseName: courseName.replace(/"/g, ""),
          index,
          ...module,
        });
      });
    });
    setFees(fee);
  }, [data])
  
  return (
    <CommonModal
      isOpen={open}
      toggler={() => setOpen(false)}
      successText={'Close'}
      title='Payment Details'
      showCloseBtn={true}
      success={() => setOpen(false)}
      bodyClass='full-screen-modal'
      size="lg"
    >
      <div className='ant-design-table not-margin'>

        <Table
          columns={generalInfoColumns}
          bordered={true}
          pagination={false}
          scroll={{ x: "auto" }}
          dataSource={[data]} />
      </div>
      <div className='ant-design-table not-margin'>

        <Table
          columns={feeData}
          bordered={true}
          pagination={false}
          scroll={{ x: "auto" }}
          dataSource={fees} />
      </div>
    </CommonModal>
  )
}

export default FeeHistory